let sharing = false

/** Keep exports in private cache only while the system share sheet needs them. */
export async function shareDownloadFile(
	blob: Blob,
	filename: string,
): Promise<boolean> {
	const { Filesystem, Directory, Encoding } = await import(
		'@capacitor/filesystem'
	)
	const safeName =
		filename.replace(/[^a-zA-Z0-9._-]/g, '_') || 'tunetoss-history.csv'
	const path = `history-exports/${crypto.randomUUID()}/${safeName}`
	const isZip = blob.type === 'application/zip'
	const data = isZip
		? await new Promise<string>((resolve, reject) => {
				const reader = new FileReader()
				reader.onload = () =>
					resolve(String(reader.result).split(',')[1])
				reader.onerror = () => reject(reader.error)
				reader.readAsDataURL(blob)
			})
		: await blob.text()
	const { uri } = await Filesystem.writeFile({
		path,
		directory: Directory.Cache,
		data,
		...(isZip ? {} : { encoding: Encoding.UTF8 }),
		recursive: true,
	})
	try {
		return await presentShare({ files: [uri] })
	} finally {
		await Filesystem.rmdir({
			path: path.slice(0, path.lastIndexOf('/')),
			directory: Directory.Cache,
			recursive: true,
		}).catch(() => {
			console.warn('Could not remove temporary export from app cache')
		})
	}
}

async function presentShare(options: {
	url?: string
	files?: string[]
}): Promise<boolean> {
	if (sharing) return false
	sharing = true
	try {
		const { Share } = await import('@capacitor/share')
		await Share.share(options)
		return true
	} catch (error) {
		if (error instanceof Error && error.message === 'Share canceled')
			return false
		throw error
	} finally {
		sharing = false
	}
}
